<div class="record-main">
    <div class="record" (click)="manageRecording()">
        <div class="record-bg" [class]="recording?'recording':''">
            <img class="record-icon" src="../../../assets/icons/recordIcon.svg" />
        </div>
    </div>
    <p class="recording-text" *ngIf="recording">Recording...</p>
    <button class="btn btn-primary" *ngIf="recording" (click)="stopRecording()">Stop Recording</button>
</div>
<!-- <ngx-audio-player [audioFiles]="audioFiles"></ngx-audio-player> -->